import React from 'react';
import ModuleLayout from '../../components/ModuleLayout';

const CalfMilkReplacerLayout = () => (
  <ModuleLayout moduleTitle="Calf Milk Ration" moduleName="calf-milk-ration" />
);

export default CalfMilkReplacerLayout;
